import Alpine from "alpinejs";
import "lazysizes";
import AOS from "aos";
import "aos/dist/aos.css";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import Swiper from "swiper";
import "swiper/css";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";


import { initLightbox } from "./lightbox.js";

// Components

// Global
window.Alpine = Alpine;

// Inits
Alpine.start();

window.addEventListener("load", () => {
	AOS.init({
		duration: 600,
		offset: 100,
		once: true,
	});
});


// Burger menus
document.addEventListener('DOMContentLoaded', function () {

	CookieConsent.run({
		guiOptions: {
			consentModal: {
				layout: "box",
				position: "bottom left",
				equalWeightButtons: true,
				flipButtons: false,
			},
			preferencesModal: {
				layout: "box",
				position: "right",
				equalWeightButtons: true,
				flipButtons: false,
			},
		},
		categories: {
			necessary: {
				readOnly: true,
			},
			analytics: {
				enabled: true,
			},
		},
		language: {
			default: "en",
			autoDetect: "browser",
			translations: {
				en: {
					consentModal: {
						title: "We value your privacy",
						description: "This website uses cookies to enhance your experience and improve our services. By continuing to browse, you agree to our use of cookies. We use functional cookies for the smooth operation of the website and analytics cookies via Google Analytics to understand how our site is used and how we can improve your experience.",
						acceptAllBtn: "Accept all",
						acceptNecessaryBtn: "Reject all",
						showPreferencesBtn: "Manage preferences",
						footer: "",
					},
					preferencesModal: {
						title: "Consent Preferences Center",
						acceptAllBtn: "Accept all",
						acceptNecessaryBtn: "Reject all",
						savePreferencesBtn: "Save preferences",
						closeIconLabel: "Close modal",
						serviceCounterLabel: "Service|Services",
						sections: [
							{
								title: "Cookie Usage",
								description: "This website uses cookies to enhance functionality and improve user experience. Cookies are small data files stored on your device. While some cookies are essential for the operation of this website, others help us understand how our site is used, enabling us to provide a better user experience.",
							},
							{
								title: 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
								description: "These cookies are essential for the basic functionalities of the website and are automatically enabled when you use the site. They include cookies that help with site security, load balancing, and management of network traffic, ensuring efficient browsing.",
								linkedCategory: "necessary",
							},
							{
								title: "Analytics Cookies",
								description: "Analytics cookies help us improve our website by collecting and reporting information on its usage. By analysing this data, we can understand visitor behavior and enhance our site to offer a better user experience. These cookies collect information in a way that does not directly identify anyone. Your consent to use these cookies helps us to provide a more personalised and efficient service.",
								linkedCategory: "analytics",
							},
							{
								title: "More information",
								description: "For further details about our cookie policy or if you have any queries regarding how we handle cookies and your choices, please contact us.",
							},
						],
					},
				},
			},
		},
	});

	//remove no-js from <html>
	document.documentElement.classList.remove('no-js');

	initLightbox();


	function initHomeCtaSwiper() {
		var swipers = document.querySelectorAll('.home-cta-swiper');

		swipers.forEach(function (swiperContainer) {
			var slider = swiperContainer.closest('.home-cta-slider');
			if (!slider) {
				return;
			}

			var nextButton = slider.querySelector('.home-cta-swiper-next');
			var prevButton = slider.querySelector('.home-cta-swiper-prev');
			var slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
			var swiperOptions = {
				modules: [Navigation],
				slidesPerView: 1,
				loop: slideCount > 1,
				autoHeight: true,
				allowTouchMove: slideCount > 1,
			};

			if (nextButton && prevButton) {
				swiperOptions.navigation = {
					nextEl: nextButton,
					prevEl: prevButton,
				};
			}

			new Swiper(swiperContainer, swiperOptions);
		});
	}
	initHomeCtaSwiper();

});
